import * as React from "react";
import { Page, Card, Alert, Text } from "tabler-react";
import TradesSiteWrapper from "./TradesSiteWrapper.react";
import RefreshButton from "./RefreshButton.react";
import { getLogs } from "./api";

class LogsPage extends React.Component {
  state = { loading: true, error: "", lines: [] };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const resp = await getLogs(400, "ALL");
      const lines = (resp.text_plain || "").split("\n").filter((l) => l.trim()).slice(-80);
      this.setState({ lines, loading: false });
    } catch (e) {
      this.setState({ error: e.message || "Failed to load logs", loading: false });
    }
  };

  render() {
    const { loading, error, lines } = this.state;
    return (
      <TradesSiteWrapper>
        <Page.Content
          title="Service Logs"
          subTitle="Recent log lines — not loaded on dashboard."
          options={<RefreshButton onClick={this.load} loading={loading} />}
        >
          <Alert type="info">
            <span data-page-note="1">
              These lines are your trading log only. Another trader&apos;s log is not shown here.
            </span>
          </Alert>
          {error ? <Alert type="danger">{error}</Alert> : null}
          {loading ? <Text>Loading logs…</Text> : null}
          {!loading && !error ? (
            <Card>
              <Card.Header>
                <Card.Title>Last {lines.length} lines</Card.Title>
              </Card.Header>
              <Card.Body>
                <pre style={{ maxHeight: "70vh", overflow: "auto", fontSize: "0.78rem", whiteSpace: "pre-wrap" }}>
                  {lines.join("\n")}
                </pre>
              </Card.Body>
            </Card>
          ) : null}
        </Page.Content>
      </TradesSiteWrapper>
    );
  }
}

export default LogsPage;
